"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.THEMES = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.log-utils");

var _gerenciatdUnifiedcomponents = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.input"));

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.js-utils");

require("./searcher.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const THEMES = {
  WHITE_1: 'white-1'
};
exports.THEMES = THEMES;

class Searcher extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "getInputTheme", theme => {
      switch (theme) {
        default:
          return _gerenciatdUnifiedcomponents.THEME.BOX;
      }
    });

    _defineProperty(this, "boldSearch", (label, queryString) => {
      const searchedWord = queryString || '';
      let htmlNameRes = label || '';
      const indexContains = label.toLowerCase().indexOf(queryString.toLowerCase());
      const lenghtOfTypped = searchedWord ? searchedWord.length : 0;

      if (htmlNameRes && indexContains > -1) {
        const noBoldString = label.substring(indexContains, indexContains + lenghtOfTypped);
        htmlNameRes = htmlNameRes.replace(noBoldString, `<span class="hightligted">${noBoldString}</span>`);
        htmlNameRes = `<span class="resultItemLabel">${htmlNameRes}</span>`;
      }

      return {
        __html: htmlNameRes
      };
    });

    _defineProperty(this, "handleOnChange", queryString => {
      const {
        options,
        findByKey,
        maxResults,
        showLabelWhenNoResults,
        onFiltered
      } = this.props; // only if there initials options we must filter

      if (options) {
        let newOptions = [];

        if (queryString) {
          // 1) filter options by queryString
          newOptions = [...options];
          newOptions = newOptions.filter(item => {
            const lwQueryString = queryString.toLowerCase();
            const currentField = item[findByKey].toLowerCase();
            const res = currentField.indexOf(lwQueryString) !== -1;
            return res;
          }); // 1.1) aply maxResults props

          newOptions.splice(maxResults); // 2) bold filtered result

          newOptions = newOptions.map(item => {
            const label = item[findByKey];
            const htmlLabel = this.boldSearch(label, queryString);
            return _objectSpread(_objectSpread({}, item), {}, {
              htmlLabel
            });
          }); // 3) we got every option  bolder
          // 4) if we didnt have any results

          if (newOptions.length === 0 && showLabelWhenNoResults) {
            const emptyItem = {
              id: 0
            };
            emptyItem.htmlLabel = {
              __html: '<span class="resultItemLabel">No se encontraron resultados<span>'
            };
            newOptions.push(emptyItem);
          }
        }

        if (onFiltered) {
          onFiltered({
            newOptions,
            queryString
          });
        }

        this.setState({
          options: newOptions
        });
      }
    });

    _defineProperty(this, "handleOnClick", item => {
      const {
        id
      } = this.state;
      const {
        findByKey,
        onClick
      } = this.props;
      const labelSelected = item[findByKey];

      if (onClick) {
        const newItem = _objectSpread({}, item);

        delete newItem.htmlLabel;
        onClick(newItem);
      }

      this.setState({
        options: [],
        queryString: labelSelected
      }, () => {
        try {
          document.getElementById(id).value = `${labelSelected}`;
        } catch (err) {
          (0, _gerenciatdUtils.errorLog)('[Searcher]: DOM not accesible');
        }
      });
    });

    _defineProperty(this, "onClean", () => {
      const {
        onClick,
        onFiltered
      } = this.props;
      const {
        id,
        queryString
      } = this.state;

      try {
        document.getElementById(id).value = '';
      } catch (err) {
        (0, _gerenciatdUtils.errorLog)('[Searcher]: DOM not accesible');
      }

      this.setState({
        options: [],
        queryString: ''
      });

      if (onClick) {
        onClick(null);
      }

      const newOptions = [];

      if (onFiltered) {
        onFiltered({
          newOptions,
          queryString
        });
      }
    });

    this.state = {
      options: [],
      queryString: '',
      id: `searcher-input-${_gerenciatdUtils2.common.giveRandomNumber(1, 10)}`
    };
  }

  render() {
    const {
      svgIconProps,
      theme,
      onClick,
      placeHolder,
      maxLength,
      SvgIconLoader
    } = this.props;
    const {
      options,
      id
    } = this.state;

    if (!onClick) {
      (0, _gerenciatdUtils.errorLog)('[Searcher: If you dont send any function, you could not recover the item selected]', 'Searcher-noOnclick');
      return null;
    }

    const inputTheme = this.getInputTheme(theme);
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "OptionsSearcher",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        id: id,
        actionInput: this.handleSearch,
        svgIconProps: svgIconProps,
        theme: inputTheme,
        onChange: this.handleOnChange,
        placeHolder: placeHolder,
        taggingInfo: {
          debug: true
        },
        cleanAction: this.onClean,
        maxLength: maxLength,
        SvgIconLoader: SvgIconLoader,
        cleanButton: true
      }), options.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "SearcherResults",
        children: options.map(item => {
          const {
            htmlLabel
          } = item;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            className: "ResultItem",
            onClick: () => this.handleOnClick(item),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              dangerouslySetInnerHTML: htmlLabel
            })
          }, item.id);
        })
      })]
    });
  }

}

Searcher.propTypes = {
  svgIconProps: _propTypes.default.shape({
    id: _propTypes.default.string,
    kind: _propTypes.default.string,
    color: _propTypes.default.string
  }),
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    // indentifies each option
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    // string to match
    label: _propTypes.default.string // this object could have more properties, if developer needs.

  })),
  theme: _propTypes.default.string,
  taggingInfo: _propTypes.default.object,
  findByKey: _propTypes.default.string,
  placeHolder: _propTypes.default.string,
  maxLength: _propTypes.default.string,
  showLabelWhenNoResults: _propTypes.default.bool,
  onClick: _propTypes.default.func
};
Searcher.defaultProps = {
  svgIconProps: {
    id: 'Buscar',
    kind: 'L',
    color: 'black'
  },
  theme: THEMES.WHITE_1,
  options: [],
  placeHolder: '¿Qué estás buscando?',
  maxResults: 9999,
  findByKey: 'name',
  showLabelWhenNoResults: false,
  onClick: null
};
var _default = Searcher;
exports.default = _default;

//# sourceMappingURL=index.js.map